export const FETCH_ACTIVITIES_REQUEST = 'FETCH_ACTIVITIES_REQUEST';
export const FETCH_ACTIVITIES_SUCCESS = 'FETCH_ACTIVITIES_SUCCESS';
export const FETCH_ACTIVITIES_FAILURE = 'FETCH_ACTIVITIES_FAILURE';

export const fetchActivitiesRequest = () => ({ type: FETCH_ACTIVITIES_REQUEST });
export const fetchActivitiesSuccess = (data) => ({ type: FETCH_ACTIVITIES_SUCCESS, payload: data });
export const fetchActivitiesFailure = (error) => ({ type: FETCH_ACTIVITIES_FAILURE, payload: error });




